import { useEffect, useState } from "react";
import { useSelector } from "react-redux";


const Chat = () => {
    const { idk } = useSelector((state) => state)

    const [msg, setmsg] = useState('');
    const [heig, setheig] = useState(30);
    const [chats, setChats] = useState([]);
    const getreply = async () => {
        const data = { msg, idk }
        let resp = await fetch("https://backend-ecomweb.onrender.com/api/chat",
            {
                method: "post",
                body: JSON.stringify(data),
                headers: { 'Content-type': 'application/json' },
            }
        )
        if (resp.ok) {
            let res = await resp.json();
            if (res.statuscode == 1) {
                getchats(idk)
            }
        }
    }

    const getchats = async (idt) => {
        let resp = await fetch(`https://backend-ecomweb.onrender.com/api/getchats/${idt}`);
        if (resp.ok) {
            let res = await resp.json();
            if (res.statuscode === 1) {
                setChats(res.chatk)
            } else {
                alert("fail");
            }
        }
    }

    useEffect(() => {
        if (idk) {
            getchats(idk);
        }
    }, [idk])



    return (
        <>
            <h2> {idk} </h2>
            {
                chats.map((data, ind) => (
                    <ul key={ind}>
                        <li id="msgk"> {data.msg} </li>
                        <li className="replk"> {data.reply} </li>
                    </ul>
                ))
            }
            <div className="input-group mb-1 m-5">
                <input type="text" className="form-control" onChange={(e) => setmsg(e.target.value)} id="myInput" height={`${heig}px`} aria-describedby="button-addon2" />
                <button onClick={getreply} className="btn btn-primary" type="button" id="button-addon2">Send</button>
            </div>

        </>
    );
}

export default Chat;